import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Etioncabforoutstation() {



  const cardData =
  {
    keyword: 'Etios Cab for Outstation in Pune',
    heading: 'Sanavi Travels: Etios Cab for Outstation in Pune',
    headingDescription: 'Sanavi Travels offers reliable Etios Cab for Outstation in Pune, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, and small groups planning long-distance trips from Pune to nearby cities and tourist destinations. Our fleet of Toyota Etios cabs is well-maintained with spacious seating, air-conditioning, and adequate luggage space, ensuring a smooth and relaxing outstation journey. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Aurangabad, Kolhapur, and Konkan. Choose Sanavi Travels for trusted Etios cab services for outstation travel in Pune, delivering comfort, safety, and a seamless long-distance travel experience.',

    top: 'Top Places to Visit in Outstation Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune, known for its lush green hills, waterfalls, and pleasant climate. Key attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla Caves. The hill station is ideal for trekking, nature walks, and weekend getaways from Pune."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a scenic hill station in the Western Ghats, famous for viewpoints like Arthur’s Seat, Elephant’s Head Point, and Bombay Point. Venna Lake, Mapro Garden, and Pratapgad Fort are major attractions. It is popular for strawberry farms, trekking, and panoramic valley views."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar is a serene destination near Pune, famous for the Bhimashankar Jyotirlinga Temple and the Bhimashankar Wildlife Sanctuary. Visitors can enjoy trekking, Kushalgarh Waterfall, and exploring the Western Ghats’ rich flora and fauna. It is a perfect blend of spirituality and nature."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani is a charming hill station known for Table Land, the second-longest mountain plateau in Asia. Popular attractions include Sydney Point, Parsi Point, and Lingmala Waterfall. The town is famous for its strawberry farms, scenic viewpoints, and peaceful environment, making it ideal for weekend trips."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a planned hill city near Pune, known for its picturesque lakes, walking trails, and modern architecture. It offers boating, water sports, and leisure activities amidst scenic surroundings. Lavasa is popular for short getaways and family trips from Pune."
  },
  {
    "title": "Khandala",
    "description": "Khandala, adjacent to Lonavala, is a serene hill station with scenic viewpoints, lush valleys, and waterfalls. Popular spots include Duke’s Nose, Rajmachi Fort, and Tiger’s Leap. It is ideal for trekking, nature photography, and monsoon trips from Pune."
  },
  {
    "title": "Matheran",
    "description": "Matheran is a unique hill station with a vehicle-free environment, offering tranquility and natural beauty. Key attractions include Panorama Point, Louisa Point, Echo Point, and Charlotte Lake. Trekking, toy train rides, and serene viewpoints make it a perfect outstation escape."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town near Pune, known for its beaches, forts, and water sports. Popular spots include Alibaug Beach, Kolaba Fort, and Kihim Beach. Alibaug is ideal for relaxing seaside getaways, weekend trips, and adventure activities from Pune."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune, famous for vineyards, temples, and the Godavari River. Key attractions include Trimbakeshwar Temple, Sula Vineyards, Pandavleni Caves, and Ramkund. It is popular for wine tours, spiritual visits, and heritage exploration."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a serene hill station near Pune, known for its scenic landscapes, waterfalls, and Vipassana meditation center. Attractions include Bhatsa River Valley, Camel Valley, and Tringalwadi Fort. It is ideal for trekking, meditation retreats, and monsoon trips from Pune."
  }
]
,




"services": [
  {
    "name": "Etios Cab for Outstation in Pune",
    "description": "Etios Cab for Outstation in Pune provides a reliable and comfortable travel solution for long-distance journeys to neighboring cities, tourist spots, and hill stations. The Etios is spacious enough to accommodate up to four passengers comfortably with ample luggage space. Fully air-conditioned and well-maintained, it ensures a smooth and enjoyable ride. Professional chauffeurs with extensive knowledge of routes ensure timely pickups, safe driving, and a stress-free journey. This service is ideal for family trips, corporate travel, group excursions, and weekend getaways where comfort, safety, and convenience are a priority."
  },
  {
    "name": "Etios Cab Hire Pune",
    "description": "Etios Cab Hire in Pune offers convenient and flexible options for individuals, families, and corporate travelers who need a reliable vehicle for local city travel, airport transfers, or sightseeing. The Etios provides a spacious and comfortable cabin, air-conditioning, and modern interiors for a smooth travel experience. Chauffeurs are professional, courteous, and punctual, ensuring stress-free journeys. With competitive pricing, easy online booking, and transparent packages, this service caters to short trips, long-distance travel, and special events, providing a dependable transport solution for all travel needs."
  },
  {
    "name": "AC Etios Cab Pune",
    "description": "AC Etios Cab in Pune guarantees a cool and comfortable travel experience throughout the year. Perfect for city tours, airport transfers, and outstation trips, the fully air-conditioned Etios provides ample legroom, comfortable seating, and luggage space. Experienced drivers ensure safe and efficient travel, navigating traffic and selecting optimal routes. Passengers can enjoy modern amenities, clean interiors, and a smooth ride, making the journey pleasant and convenient. This service is ideal for families, corporate groups, tourists, and anyone looking for a reliable, comfortable, and professional cab experience in Pune."
  },
  {
    "name": "Outstation Etios Cab Pune",
    "description": "Outstation Etios Cab Pune provides convenient and comfortable transport for trips beyond Pune to nearby cities and tourist destinations. Equipped with ample seating and luggage space, the Etios is perfect for families, groups, or business travelers. Professional chauffeurs follow safe and optimized routes to ensure timely arrivals, while passengers enjoy a smooth, air-conditioned ride. Flexible packages for one-way or round trips, along with affordable pricing, make this service suitable for weekend getaways, long-distance travel, corporate trips, and sightseeing excursions. Comfort, safety, and reliability are guaranteed throughout the journey."
  },
  {
    "name": "Affordable Etios Cab Pune",
    "description": "Affordable Etios Cab in Pune offers budget-friendly transportation without compromising on quality, comfort, or safety. Ideal for families, groups, and corporate travelers, this service provides spacious, air-conditioned cabs suitable for city travel, airport pickups, and outstation trips. Professional chauffeurs ensure smooth rides, timely arrivals, and courteous service. Transparent pricing and flexible booking options make it easy for travelers to plan trips without worrying about hidden costs. This service combines affordability, convenience, and comfort for a seamless travel experience across Pune and nearby destinations."
  },
  {
    "name": "Chauffeur Driven Etios Cab",
    "description": "Chauffeur Driven Etios Cab in Pune offers a premium and stress-free travel experience for both local and outstation trips. Experienced and courteous drivers handle all navigation, traffic, and route planning, allowing passengers to relax or focus on work during the journey. The Etios is spacious, fully air-conditioned, and equipped with modern interiors, ensuring comfort for up to four passengers. Ideal for family trips, corporate travel, airport transfers, and long-distance journeys, this service prioritizes safety, punctuality, and convenience, making every ride smooth and enjoyable."
  },
  {
    "name": "Best Etios Cab Pune",
    "description": "Best Etios Cab Pune provides top-quality vehicles with professional chauffeur service for a comfortable, safe, and reliable travel experience. The Etios offers spacious seating, air-conditioning, ample luggage space, and smooth driving for city tours, airport transfers, and outstation trips. Experienced drivers ensure timely arrivals, safe travel, and courteous service, making it ideal for family vacations, corporate travel, sightseeing tours, and weekend getaways. This service combines premium service, competitive pricing, and hassle-free booking, ensuring every journey is pleasant, convenient, and stress-free."
  },
  {
    "name": "Pune Etios Taxi",
    "description": "Pune Etios Taxi provides a dependable and comfortable travel solution for local city travel, airport transfers, corporate trips, and family outings. Spacious, air-conditioned, and well-maintained, the Etios accommodates up to four passengers and luggage comfortably. Professional chauffeurs ensure safe, timely, and smooth rides, while passengers enjoy modern interiors and convenient amenities. Ideal for short trips, city tours, and special occasions, this taxi service emphasizes comfort, reliability, and affordability, making it a preferred choice for travelers in Pune."
  },
  {
    "name": "Corporate Etios Cab Pune",
    "description": "Corporate Etios Cab in Pune caters to business travelers, executives, and corporate groups seeking professional, reliable, and comfortable transportation. The spacious, air-conditioned Etios provides a comfortable cabin for meetings, work during travel, or relaxation. Chauffeurs are experienced, punctual, and courteous, ensuring safe and efficient travel for airport transfers, client visits, team outings, and corporate events. Flexible packages, competitive pricing, and professional service make this cab ideal for companies and employees seeking a dependable and stress-free travel solution."
  },
  {
    "name": "Family Etios Cab Pune",
    "description": "Family Etios Cab Pune provides a safe, comfortable, and spacious travel experience for families exploring Pune or traveling to nearby destinations. With seating for up to four passengers and ample luggage space, these cabs are perfect for city tours, weekend trips, or long-distance journeys. Fully air-conditioned and well-maintained, the Etios ensures a smooth and pleasant ride. Professional chauffeurs provide courteous, reliable, and punctual service, allowing families to enjoy a stress-free travel experience with convenience, comfort, and safety as top priorities."
  },
  {
    "name": "Airport Etios Cab Pune",
    "description": "Airport Etios Cab Pune provides timely and hassle-free pickups and drop-offs for travelers heading to or from Pune airports. The spacious, air-conditioned Etios can comfortably accommodate passengers and luggage. Professional chauffeurs ensure safe driving, efficient routes, and punctual service, allowing passengers to avoid airport delays and enjoy a stress-free journey. Perfect for both business and leisure travelers, this service ensures convenience, reliability, and comfort for all airport travel requirements."
  },
  {
    "name": "Tourist Etios Cab Pune",
    "description": "Tourist Etios Cab Pune offers a reliable and comfortable option for sightseeing, leisure trips, and exploring Pune and surrounding attractions. The spacious, air-conditioned Etios provides ample legroom, luggage space, and modern interiors for a pleasant travel experience. Professional chauffeurs guide passengers through scenic routes, city roads, and tourist destinations, ensuring safe and smooth rides. Suitable for families, friends, and groups, this service combines convenience, comfort, and affordability to make every sightseeing or leisure trip enjoyable and memorable."
  },
  {
    "name": "Long Distance Etios Cab Pune",
    "description": "Long Distance Etios Cab Pune provides a reliable and comfortable travel solution for journeys beyond Pune, whether for business, leisure, or family trips. Spacious, air-conditioned, and well-maintained, the Etios can comfortably accommodate passengers and luggage for extended travel. Experienced chauffeurs ensure safe, punctual, and efficient routes, making long-distance journeys stress-free and enjoyable. Flexible packages for one-way, round trips, or customized itineraries make this service perfect for weekend getaways, tourist excursions, or corporate travel."
  },
  {
    "name": "One Way Etios Cab Pune",
    "description": "One Way Etios Cab Pune offers a convenient and cost-effective travel option for passengers traveling from Pune to a specific destination without needing a return trip. The air-conditioned, spacious Etios ensures comfort and safety throughout the journey. Professional chauffeurs handle traffic, routes, and timely pickups, ensuring a smooth and stress-free ride. Ideal for airport transfers, outstation trips, and city-to-city travel, this service provides flexibility, convenience, and reliability for one-way travel needs."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking for Etios Cabs in Pune allows travelers to reserve their vehicle quickly and conveniently via website or app. Passengers can select pickup location, cab type, travel date, and timing with instant confirmation. The Etios offers spacious, air-conditioned interiors with modern amenities for a comfortable ride. Professional chauffeur service ensures punctuality, safety, and efficiency. Suitable for local trips, outstation travel, airport transfers, sightseeing tours, and group travel, this online booking service combines technology, convenience, and professional transport for a seamless travel experience."
  }
],
"tableData": [
  ["Etios Cab for Outstation in Pune", "Etios Cab Hire Pune"],
  ["AC Etios Cab Pune", "Outstation Etios Cab Pune"],
  ["Affordable Etios Cab Pune", "Chauffeur Driven Etios Cab"],
  ["Best Etios Cab Pune", "Pune Etios Taxi"],
  ["Corporate Etios Cab Pune", "Family Etios Cab Pune"],
  ["Airport Etios Cab Pune", "Tourist Etios Cab Pune"],
  ["Long Distance Etios Cab Pune", "One Way Etios Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]

,


"whychoose": [
  {
    "WhyChooseheading": "Etios Cab for Outstation in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Etios cab services from Pune for outstation trips, ideal for family travel, weekend getaways, corporate journeys, and long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Etios Cars",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced Etios cabs for a smooth and enjoyable journey to your outstation destination."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous and familiar with Pune and outstation routes, ensuring safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Etios cab rentals from Pune, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Outstation Packages",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized outstation cab packages to suit your travel plans."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Etios cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Etios cabs for outstation trips from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Etios cab services for outstation travel from Pune?',
    answer: 'Yes, Sanavi Travels offers well‑maintained and comfortable Etios cabs for outstation travel from Pune.'
  },
  {
    question: 'How can I book an Etios cab for outstation from Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of trips are suitable with an Etios cab?',
    answer: 'Etios cab rentals are perfect for outstation trips, airport transfers, family travel, weekend getaways, and corporate travel.'
  },
  {
    question: 'Are drivers included with the Etios cab booking?',
    answer: 'Yes, all Etios cab bookings include experienced and professional drivers.'
  },
  {
    question: 'Is the Etios cab service available 24x7?',
    answer: 'Yes, our Etios cab service from Pune for outstation travel is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all Etios cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize my outstation cab package?',
    answer: 'Absolutely. Sanavi Travels offers customized outstation packages based on your travel requirements.'
  },
  {
    question: 'What payment options are available for Etios cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Etios cab trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Booked an Etios cab for an outstation trip from Pune with Sanavi Travels. Comfortable ride, smooth journey, and excellent service throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ayesha Khan',
    feedback: 'Great experience! The Etios cab was clean, the driver was professional, and the travel was hassle‑free. Highly recommend Sanavi Travels.',
    rating: 5
  }
];




















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Etios Cab for Outstation in Pune - Sanavi Travels",
  "description": "Book Etios cabs for outstation travel from Pune with Sanavi Travels. AC and comfortable Etios cabs for family trips, corporate travel, airport transfers, long-distance journeys, one-way or round trips, and chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Etios Cab for Outstation in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and comfortable Etios cabs from Pune for outstation travel with Sanavi Travels. Ideal for family trips, corporate journeys, airport transfers, long-distance travel, one-way or round trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Etioncabforoutstation;